import { render, staticRenderFns } from "./mycomment.vue?vue&type=template&id=7da410b8&scoped=true&"
import script from "./mycomment.vue?vue&type=script&lang=js&"
export * from "./mycomment.vue?vue&type=script&lang=js&"
import style0 from "./mycomment.vue?vue&type=style&index=0&id=7da410b8&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da410b8",
  null
  
)

export default component.exports